const Badge = ({ categoryName }) => {
  return (
    <span className="absolute top-1 right-0 items-center inline-flex mt-3 mr-3 px-2.5 py-0.5 rounded-md z-10 bg-red-100 dark:bg-green-100 text-xs font-semibold tracking-wide select-none ">
      <p className="text-xs text-red-800 dark:text-green-900">{categoryName}</p>
    </span>
  );
};

export default Badge;
